import { theme } from '@theme';

export const MenuContainer = {
  background: theme.palette.common.white,
  padding: '48px 24px 16px 24px'
};

export const MenuSectionContainer = {
  maxWidth: '1320px',
  marginInline: 'auto'
};

export const MenuTitle = {
  color: theme.palette.common.primaryDark,
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '600',
  marginBottom: '16px'
};

export const MenuLink = {
  cursor: 'pointer',
  display: 'block',
  color: theme.palette.common.darkBlue2,
  fontSize: '16px',
  fontWeight: '400',
  textDecoration: 'unset',
  padding: '12px 0px'
};

export const FooterContainer = {
  background: theme.palette.common.white,
  padding: '32px 24px',
  borderTop: '1px solid #C6C8C8'
};

export const FooterSectionContainer = {
  maxWidth: '1320px',
  marginInline: 'auto',
  flexDirection: 'row',
  '@media only screen and (min-width: 320px) and (max-width: 745px)': {
    flexDirection: 'column'
  }
};

export const footerCopyright = {
  color: theme.palette.common.darkBlue2,
  fontSize: '14px',
  fontWeight: '400',
  width: '100%',
  textAlign: 'right',
  '@media only screen and (min-width: 320px) and (max-width: 745px)': {
    textAlign: 'left',
    marginTop: '16px'
  }
};

export const FooterLinksContainer = {
  flex: '1',
  display: 'flex',
  alignItems: 'center',
  gap: '16px'
};

export const FooterLink = {
  cursor: 'pointer',
  color: theme.palette.common.darkBlue2,
  fontSize: '14px',
  fontWeight: '400',
  textDecoration: 'underline'
};

export const chinaFooterNoticeContainer = {
  background: theme.palette.common.brandPPurple,
  padding: '32px 24px',
  display: 'flex',
  justifyContent: 'center'
};

export const chinaFooterNoticeText = {
  color: theme.palette.common.white,
  fontSize: '16px',
  fontWeight: '400',
  lineHeight: '24px',
  textAlign: 'center'
};

export const chinaFooterNoticeLink = {
  color: theme.palette.common.lightBlue3,
  fontSize: '16px',
  fontWeight: '400',
  lineHeight: '24px',
  textDecoration: 'underline'
};
